import { Coordinates, CalculationMethod, PrayerTimes, SunnahTimes } from 'adhan';
import Compass from './compass';

window.addEventListener("DOMContentLoaded", (event) => {

        const compassCircle = document.querySelector(".compass-circle");

        let latitude;
        let longitude;
        let compass;
        let inited = false;
        let orientation = null;
        let countDownInterval;
        let secondsLeftms;
        let endTime;
        let countDownTime;
        let userLocation;
        let directionAngle;
        // Magnetic declination at the user's position (degrees, E positive),
        // fetched from our own WMM2025 route once Location services is on.
        // The heading stream is magnetic-north referenced while the qibla
        // bearing is true-north referenced, so the arrow must be rotated
        // back by this amount to point at the true qibla.
        let declination = 0;
        const countDown = document.querySelector('#countdown');
        let timeMethod = "Tehran"
        const isIOS =
                navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
                navigator.userAgent.match(/AppleWebKit/);
        //TODO:

        let calculationMethod = localStorage.getItem('calculation-method') ?? 'MuslimWorldLeague';

        document.querySelector('#calculation-method').value = calculationMethod;

        const qiblaPoint = {
                lat: 21.422487,
                lng: 39.826206,
        };


        //sahre location

        document.getElementById('share_location').addEventListener('click', async function () {

                shareQibla();

        });

        function setCookie(name, value) {
                const expires = new Date();
                expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
                const expiresString = "expires=" + expires.toUTCString();

                document.cookie = name + "=" + value + ";" + expiresString + ";path=/";
        }

        //change prayer time method

        document.querySelector('#calculation-method').addEventListener('change', (e) => {

                timeMethod = e.target.value;

                localStorage.setItem('calculation-method', timeMethod);

                if (latitude && longitude) {

                        setPrayerTime(timeMethod);
                }

        });

        //Change Lang

        document.querySelector(".language").addEventListener("click", function () {

                document.querySelector(".lang").classList.toggle("active");
        })

        //Change theme

        document.querySelector(".change-theme").addEventListener("click", function () {

                document.querySelector(".colors").classList.toggle("active");
        });

        //Change Color

        document.querySelectorAll(".color").forEach(el => {

                el.addEventListener("click", function () {

                        document.querySelector(".color.active").classList.remove("active");

                        el.classList.add("active");

                        if (el.classList.contains("active")) {

                                var rotateVal = el.getAttribute("data-id");
                                var color = el.style.backgroundColor;

                                document.querySelector(".compass").style.filter =
                                        `hue-rotate(${rotateVal}deg)`;

                                document.documentElement.style.setProperty("--main-color", color);

                                document.querySelector(".info-text").style.filter =
                                        `hue-rotate(${rotateVal}deg)`;

                                document.querySelector(".prayer-time .active .head").style.filter =
                                        `hue-rotate(${rotateVal}deg)`;


                                document.querySelector(".prayer-time .active i").style.filter =
                                        `hue-rotate(${rotateVal}deg)`;

                                document.querySelector(".prayer-time .active span:last-of-type").style.filter =
                                        `hue-rotate(${rotateVal}deg)`;
                        }

                })

        });

        document.querySelector(".toggle")?.addEventListener("click", function (e) {

                e.preventDefault();

                this.classList.toggle("toggle-on");

                document.querySelector(".info-text").classList.toggle('active');

                if (this.classList.contains("toggle-on")) {

                        initPremissions();

                        startOrientationListeners();
                }
        })

        // Chrome/Edge Android fire deviceorientationabsolute; Firefox
        // Android and some WebViews only fire the generic deviceorientation.
        // Same proven pattern as the homepage compass: start absolute-only,
        // fall back to the generic event after 1.5s of silence, and the
        // first absolute event removes the fallback for good (feeding both
        // made the homepage dial oscillate).
        let absoluteFallbackTimer = null;
        let orientationListenersOn = false;

        function onAbsoluteOrientation(event) {
                if (absoluteFallbackTimer !== null) {
                        clearTimeout(absoluteFallbackTimer);
                        absoluteFallbackTimer = null;
                }
                window.removeEventListener("deviceorientation", onGenericOrientation, true);
                updateRotationAndQibla(event);
        }

        function onGenericOrientation(event) {
                updateRotationAndQibla(event);
        }

        function startOrientationListeners() {
                if (orientationListenersOn) return;
                orientationListenersOn = true;

                if (isIOS) {

                        window.addEventListener("deviceorientation", onGenericOrientation, true);
                } else {

                        window.addEventListener("deviceorientationabsolute", onAbsoluteOrientation, true);

                        absoluteFallbackTimer = setTimeout(() => {
                                absoluteFallbackTimer = null;
                                window.addEventListener("deviceorientation", onGenericOrientation, true);
                        }, 1500);
                }
        }

        async function initPremissions() {

                // iOS rejects requestPermission() outright (no prompt) when
                // it was denied before — without this try/catch the whole
                // chain died before geolocation and the page stayed silent.
                try {
                        if (typeof window.DeviceOrientationEvent?.requestPermission === "function") {

                                const permission = await window.DeviceOrientationEvent.requestPermission();
                                orientation = permission === "granted";

                        } else if (window.DeviceOrientationEvent) {

                                orientation = true;

                        } else {

                                orientation = false;
                        }
                } catch (err) {

                        orientation = false;
                }

                await initCompass();

                compass = new Compass();

                // The error callback must resolve too, or a denied/stuck
                // location permission left the await hanging forever.
                const location = await new Promise((resolve) => {
                        navigator.geolocation.getCurrentPosition(
                                (position) => resolve(position),
                                (error) => resolve({ error })
                        );
                });

                if (location && !location.error) {

                        latitude = location.coords.latitude;
                        longitude = location.coords.longitude;

                        if (!inited) {
                                showPosition();
                                inited = true;
                        }
                } else {

                        showError(location && location.error ? location.error : { code: 1 });
                        document.querySelector(".toggle")?.classList.remove("toggle-on");
                }
        }

        function showError(error) {
                // Text comes from window.QIBLA_ERRORS (set in the blade for
                // the current locale) — this file is Vite-built, blade {{
                // }} never renders here, the old raw syntax showed junk.
                const i18n = window.QIBLA_ERRORS || {};
                switch (error && error.code) {
                        case 1:
                                alert(i18n.denied || "You denied the location request.");
                                return;
                        case 2:
                                alert(i18n.unavailable || "Location information is unavailable.");
                                return;
                        case 3:
                                alert(i18n.timeout || "The location request timed out.");
                                return;
                }
        }

        function showPosition() {

                if (inited) {
                        initCompass();
                        return;
                }

                const qiblaAngle = calcQiblaDirection(latitude, longitude);
                const qiblaDirection = getCardinalDirection(qiblaAngle);

                document.querySelector(".latitude span").innerText = latitude;
                document.querySelector(".longitude span").innerText = longitude;
                directionAngle = `${qiblaDirection} ${qiblaAngle}`;
                document.querySelector(".deg span").innerText = `${qiblaDirection} ${qiblaAngle}`;

                initCompass();

                setPrayerTime();
                distanceCoordinates();
                getCurrentTimeInSaudiArabia();

                setCookie("longitude", longitude);
                setCookie("latitude", latitude);
                setCookie("userLocation", userLocation);
                setCookie("directionAngle", directionAngle);

                GetAltitude();
                GetDeclination(latitude, longitude);
        }

        function GetDeclination(latitude, longitude) {

                const base = window.GET_DECLINATION_BASE;
                if (!base) {
                        return;
                }

                // Force https only when the page itself is https (production):
                // avoids mixed content there; local http pages keep working.
                const url = (location.protocol === 'https:'
                        ? base.replace(/^http:\/\//i, 'https://')
                        : base) + `/${latitude}/${longitude}`;

                const xhr = new XMLHttpRequest();

                xhr.open('GET', url);

                xhr.onload = function() {

                        if (xhr.status === 200) {

                                const data = JSON.parse(xhr.responseText);
                                const value = parseFloat(data.declination);

                                if (!isNaN(value)) {
                                        declination = value;
                                }
                        } else {
                                console.error(`Error: ${xhr.status}`);
                        }
                };

                xhr.send();
        }

        // Great-circle initial bearing to the Kaaba, degrees clockwise from
        // true north, unrounded — the displayed tile rounds it via
        // calcQiblaDirection. The arrow uses the exact value so it always
        // matches the number shown to the user.
        function qiblaBearingExact(userLatitude, userLongitude) {
                const phi1 = (userLatitude * Math.PI) / 180;
                const lambda1 = (userLongitude * Math.PI) / 180;
                const phi2 = (qiblaPoint.lat * Math.PI) / 180;
                const lambda2 = (qiblaPoint.lng * Math.PI) / 180;

                const deltaLambda = lambda2 - lambda1;
                const y = Math.sin(deltaLambda) * Math.cos(phi2);
                const x =
                        Math.cos(phi1) * Math.sin(phi2) -
                        Math.sin(phi1) * Math.cos(phi2) * Math.cos(deltaLambda);

                let psi = (Math.atan2(y, x) * 180) / Math.PI;

                if (psi < 0) {
                        psi += 360;
                }

                return psi;
        }

        function calcQiblaDirection(userLatitude, userLongitude) {
                return Math.round(qiblaBearingExact(userLatitude, userLongitude));
        }

        function getCardinalDirection(degree) {
                const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];

                const index = Math.round(degree / 45) % 8;

                return directions[index >= 0 ? index : index + 8];
        }

        async function initCompass() {

                if (!latitude || !longitude || compass == undefined) {
                        return;
                }

                if (orientation && !inited) {
                        if (compass && typeof compass.allowOrientationPermissions === 'function') {
                                await compass.allowOrientationPermissions();
                        }
                }

                await compass.init(updateRotationAndQibla);
        }

        function updateRotationAndQibla(event) {
                if (!compass) return;

                let deg = 0;

                // Real orientation frames carry a compass reading; the
                // one-shot compass.init callback passes no event. Without a
                // live magnetic heading (no magnetometer) the arrow is a
                // static pointer and must show the true bearing itself,
                // not bearing − declination.
                let headingDelta = 0;
                const hasHeading = !!(event &&
                        (event.webkitCompassHeading != null || event.alpha != null));

                if (hasHeading) {
                        // Read the heading from the event itself (same math
                        // as compass.js) — compass.deviceAngleDelta is fed by
                        // compass.js's own absolute-only listener, which never
                        // fires on browsers without deviceorientationabsolute
                        // (Firefox Android), and it lags this frame anyway.
                        if (typeof event.webkitCompassHeading === "number") {
                                headingDelta = 360 - event.webkitCompassHeading;
                        } else {
                                headingDelta = 360 - Math.abs(event.alpha - 360);
                        }
                }

                deg = smoothDegreeTransition(deg, Math.round(
                        headingDelta +
                        qiblaBearingExact(latitude, longitude) -
                        (hasHeading ? declination : 0)));

                document.querySelector(".compass").style.transform = `rotate(${deg}deg)`;
        }

        function smoothDegreeTransition(oldDeg, newDeg) {

                let diff = newDeg - oldDeg;

                while (diff < -180) {
                        diff += 360;
                }

                while (diff > 180) {
                        diff -= 360;
                }

                return oldDeg + diff;
        }

        function setPrayerTime(calculationMethod = 'MuslimWorldLeague') {

                // const coordinates = new Coordinates(35.3391979, 51.6291533);
                const coordinates = new Coordinates(latitude, longitude);
                const params = CalculationMethod[calculationMethod]();
                const date = new Date();
                const prayerTimes = new PrayerTimes(coordinates, date, params);
                const fajrTime = formatTime(prayerTimes.fajr);
                const ishaTime = formatTime(prayerTimes.isha);
                const maghribTime = formatTime(prayerTimes.maghrib);
                const dhuhrTime = formatTime(prayerTimes.dhuhr);
                const asrTime = formatTime(prayerTimes.asr);

                document.querySelector('.dawn span:last-of-type').innerText = fajrTime;
                document.querySelector('.noon span:last-of-type').innerText = dhuhrTime;
                document.querySelector('.afternoon span:last-of-type').innerText = asrTime;
                document.querySelector('.maghrib span:last-of-type').innerText = maghribTime;
                document.querySelector('.isha span:last-of-type').innerText = ishaTime;

                const prayerTimesArray = {
                        fajr: fajrTime,
                        isha: ishaTime,
                        maghrib: maghribTime,
                        dhuhr: dhuhrTime,
                        asr: asrTime
                };

                let nextPrayer = findNextPrayerTime(prayerTimesArray);
                let nextDayFlag = false;

                if (nextPrayer == null) {

                        nextPrayer = "fajr";

                        nextDayFlag = true;
                }

                document.querySelector(`#time-${nextPrayer}`)?.classList.add("active");

                let currentTime = getCurrentTime();


                let currentDate = new Date()
                currentDate = currentDate.toISOString().split('T')[0];
                currentDate = currentDate.replace("/-/g", "/");

                let currentDateTime = new Date(`${currentDate} ${currentTime}`);
                let nextDateTime = new Date(`${currentDate} ${prayerTimesArray[nextPrayer]}`)


                if (nextDayFlag) {

                        nextPrayer = "fajr";

                        document.querySelector(`#time-fajr`)?.classList.add("active");

                        let nextDay = new Date()
                        nextDay.setDate(nextDay.getDate() + 1);
                        getNextDayPrayerTime(nextDay);
                        nextDay = nextDay.toISOString().split('T')[0];
                        nextDay = nextDay.replace("/-/g", "/");

                        nextDateTime = new Date(`${nextDay} ${prayerTimesArray["fajr"]}`);
                }


                let difference = nextDateTime.getTime() - currentDateTime.getTime();
                let resultInMinutes = Math.floor((difference - 0 * 60000) / 60000);

                countDownTime = resultInMinutes;
                countDownTime = countDownTime * 60000;

                const now = Date.now();
                endTime = now + countDownTime;

                document.querySelector(".next-time").classList.add("active");

                setCountDown(endTime);

                countDownInterval = setInterval(() => {
                        setCountDown(endTime);
                }, 1000);
        }

        function setCountDown(endTime) {

                secondsLeftms = endTime - Date.now();
                const secondsLeft = Math.round(secondsLeftms / 1000);

                let hours = Math.floor(secondsLeft / 3600);
                let minutes = Math.floor(secondsLeft / 60) - (hours * 60);
                let seconds = secondsLeft % 60;

                if (hours < 10) {
                        hours = `0${hours}`;
                }
                if (minutes < 10) {
                        minutes = `0${minutes}`;
                }
                if (seconds < 10) {
                        seconds = `0${seconds}`;
                }

                if (secondsLeft < 0) {
                        resetCountDown();
                        return;
                }

                countDown.innerHTML = `${hours} : ${minutes} : ${seconds}`;

        }

        function getNextDayPrayerTime(day) {
                const coordinates = new Coordinates(latitude, longitude);
                const params = CalculationMethod[calculationMethod]();
                const prayerTimes = new PrayerTimes(coordinates, day, params);
                const fajrTime = formatTime(prayerTimes.fajr);

                document.querySelector('.dawn span:last-of-type').innerText = fajrTime;
        }

        function resetCountDown() {

                clearInterval(countDownInterval);
                countDown.innerHTML = '00 : 00 : 00';
        }

        function changeTimezone(date, ianatz) {


                var invdate = new Date(date.toLocaleString('en-US', {
                        timeZone: ianatz
                }));


                var diff = date.getTime() - invdate.getTime();

                return new Date(date.getTime() - diff);
        }

        function getTimeZoneFromCity(cityName) {
                // Extract the city name from the user's input
                const city = cityName.split('/')[1].trim(); // Assuming the format is "Country / City"

                // Loop through the array of IANA time zones
                for (let i = 0; i < aryIanaTimeZones.length; i++) {
                        // Check if the city name is present in the IANA time zone string
                        if (aryIanaTimeZones[i].toLowerCase().includes(city.toLowerCase())) {
                                // Return the matching time zone
                                return aryIanaTimeZones[i];
                        }
                }

                // If no matching time zone is found, return null
                return null;
        }
        
        function getCurrentTime() {
                
                const now = new Date();
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');

                return `${hours}:${minutes}`;
        }

        function timeToMinutes(time) {
                const [hours, minutes] = time.split(':').map(Number);
                return hours * 60 + minutes;
        }


        function formatTime(time) {

                return time.toLocaleTimeString('en-US', { hour12: false });
        }

        function degreesToRadians(degrees) {

                return degrees * Math.PI / 180;
        }

        function distanceCoordinates() {
                const earthRadiusKm = 6371;
                const earthRadiusMiles = 3958.8;
                const averageSpeed = 60;

                const dLat = degreesToRadians(qiblaPoint.lat - latitude);
                const dLon = degreesToRadians(qiblaPoint.lng - longitude);

                const a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(degreesToRadians(latitude)) * Math.cos(degreesToRadians(qiblaPoint.lat)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);

                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                const distanceKm = earthRadiusKm * c;
                const distanceMiles = earthRadiusMiles * c;

                const distanceKmRounded = Math.round(distanceKm);
                const distanceMilesRounded = Math.round(distanceMiles);

                document.querySelector(".distance span:last-of-type").innerText = `${distanceKmRounded.toLocaleString()} km (${distanceMilesRounded.toLocaleString()} miles)`;
        }

        function getCurrentTimeInSaudiArabia() {

                const currentDate = new Date();

                currentDate.setTime(currentDate.getTime());

                const formattedTime = currentDate.toLocaleTimeString('en-US');

                document.querySelector(".current-time span:last-of-type").innerText = formattedTime;
        }

        function timeToMinutes(time) {
                const [hours, minutes] = time.split(':').map(Number);
                return hours * 60 + minutes;
        }

        function findNextPrayerTime(prayerTimes) {
                const currentTime = getCurrentTime();                

                const times = Object.keys(prayerTimes);
                let minDifference = Infinity;
                let nextPrayer = null;

                times.forEach(prayer => {
                        const timeDifference = timeToMinutes(prayerTimes[prayer]) - timeToMinutes(currentTime);

                        if (timeDifference > 0 && timeDifference < minDifference) {
                                minDifference = timeDifference;
                                nextPrayer = prayer;
                        }
                });

                return nextPrayer;
        }


        document.querySelectorAll('.title_box h2').forEach(element => {

                element.addEventListener("click", function () {

                        element.parentElement.classList.toggle("active");
                })
        });
});